export const editMutations = <const>{
	SKLAD_MISTO_OD_SELECT_MAPPER: 'SKLAD_MISTO_OD_SELECT_MAPPER',
	SKLAD_MISTO_DO_SELECT_MAPPER: 'SKLAD_MISTO_DO_SELECT_MAPPER',
};
